import { chartColors } from '@UILibrary/utils'

const convertPercentageToFilledData = (percentage, max = 360) => {
  const filledAmount = Math.round((percentage / 100) * max);
  const remainder = max - filledAmount;
  return [filledAmount, remainder];
}

export const buildRadialBarChartDataProp = (programEngagementData) => {
  const received_coaching = parseInt(programEngagementData.received_coaching) || 0;
  const workshops_attended = parseInt(programEngagementData.workshops_attended) || 0;
  const app_logins = parseInt(programEngagementData.app_logins) || 0;
  const circumference = 360;

  return {
    labels: ['Program Engagement'],
    datasets: [
      // Actual progress bars (full colors) - render first so they're on top
      {
        label: 'Received Coaching',
        backgroundColor: [chartColors['salem-60'], chartColors['salem-0']],
        data: convertPercentageToFilledData(received_coaching, circumference),
        borderColor: chartColors['white'],
        borderWidth: 0,
        weight: 1,
        circumference,
        rotation: 0
      },
      {
        label: 'Workshops Attended',
        backgroundColor: [chartColors['true-blue-60'], chartColors['true-blue-5']],
        data: convertPercentageToFilledData(workshops_attended, circumference),
        borderColor: chartColors['white'],
        borderWidth: 0,
        weight: 1,
        circumference,
        rotation: 0
      },
      {
        label: 'App Logins',
        backgroundColor: [chartColors['rhythm-40'], chartColors['rhythm-0']],
        data: convertPercentageToFilledData(app_logins, circumference),
        borderColor: chartColors['white'],
        borderWidth: 0,
        weight: 1,
        circumference,
        rotation: 0
      },
    ]
  };
}
